import { StoreType } from "@faire/retailer-shared/lib/StoreType";
/**
 * Fields that IStyleQuiz.StyleQuizStoreType may return but do not have corresponding
 * StoreType values -- and are therefore deemed invalid.
 */ var invalidStyleQuizAnswers = [
    "STATIONERY",
    "KIDS_AND_BABY",
    "STYLE_QUIZ_STORE_TYPE_UNKNOWN"
];
export var mapStyleQuizAnswerToStoreType = function(styleQuizAnswer) {
    if (!styleQuizAnswer) {
        return;
    }
    var styleQuizAnswerToStoreType = invalidStyleQuizAnswers.includes(styleQuizAnswer) ? "OTHER" : styleQuizAnswer;
    return StoreType[styleQuizAnswerToStoreType];
};
